module.exports = __webpack_public_path__ + "static/media/HCMM615.ecce406d.jpg";